/**
 * @author salla.saishiva
 * @Date: 2023-09-14 11:30:49
 * @Last Modified by: salla.saishiva
 * @Last Modified time: 2023-09-14 16:30:49
*/

import Loadable from 'react-loadable';
import Loader from '../../../../../components/Loader';

const component = Loadable({
  loader: () => import('./index'),
  loading: Loader,
});

const loadData = () => (
  Promise.all([

  ])
);

export default {
  component,
  loadData,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/BoardOfDirectors/DirectorsProfile/Loadable.js